export default {"src":"/_next/static/media/us.229d3ab2.svg","height":16,"width":20,"blurWidth":0,"blurHeight":0};